import React, {
  useEffect,
  useRef,
  forwardRef,
  useState,
  useCallback,
} from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import './dropdown.css'

const Dropdown = forwardRef((props, ref) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [dropdownData, setDropdownData] = useState([])
  const [search, setSearch] = useState('')
  const navigate = useNavigate()
  const [showFilterDropdown, setShowFilterDropdown] = useState(false)
  const dropdownRef = useRef(null)
  useEffect(() => {
    document.addEventListener('click', (event) => {
      if (ref?.current?.contains(event?.target)) {
        setShowFilterDropdown(true)
        if (props?.resetFilters) {
          props.resetFilters('')
        }
      } else {
        if (dropdownRef?.current?.contains(event?.target)) {
          setShowFilterDropdown(true)
        } else {
          setShowFilterDropdown(false)
          setSearch('')
        }
      }
    })
    return () => {
      document.removeEventListener('click', () => {})
    }
  }, [ref, props, setSearch])

  useEffect(() => {
    if (props?.data?.length > 0) {
      if (search.trim() === '') {
        setDropdownData([...props.data])
      } else {
        setDropdownData([
          ...props.data.filter((item) =>
            item.label.toUpperCase().includes(search.trim().toUpperCase())
          ),
        ])
      }
    } else {
      setDropdownData([])
    }
  }, [setDropdownData, search, props.data])
  const changeHandler = useCallback(
    (value) => {
      if (props.isMultiple) {
        if (value === '') {
          if (props.filterName) {
            if (props.filterName === 'tag') {
              const task = searchParams.get('task')
              const card = searchParams.get('card')
              navigate(`/tasks/?tag=&task=${task}&card=${card}`)
            }
          } else {
            props.setActiveFilters([''])
          }
        } else {
          const activeFiltersTemp = [...props.activeFilters]
          const valueIndex = activeFiltersTemp.indexOf(value)
          const noFilterIndex = activeFiltersTemp.indexOf('')
          if (noFilterIndex !== -1) {
            activeFiltersTemp.splice(noFilterIndex, 1)
          }
          if (valueIndex === -1) {
            activeFiltersTemp.push(value)
          } else {
            activeFiltersTemp.splice(valueIndex, 1)
          }
          if (props.filterName) {
            if (props.filterName === 'tag') {
              navigate(
                `/tasks/?tag=${activeFiltersTemp.join(',')}&task=&card=`
              )
            }
          } else {
            props.setActiveFilters([...activeFiltersTemp])
          }
        }
      } else {
        props.setActiveFilters(value)
        setShowFilterDropdown(false)
        setSearch('')
      }
    },
    [props, searchParams, navigate, setShowFilterDropdown, setSearch]
  )
  return (
    <>
      {showFilterDropdown && props?.data?.length > 0 && (
        <div
          className={props.isExpand ? 'dropdown expand' : 'dropdown'}
          ref={dropdownRef}
        >
          {props.isSearchable && (
            <div className='search'>
              <input
                value={search}
                placeholder='Search...'
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          )}
          {dropdownData?.map((item) => (
            <div
              onClick={() => {
                changeHandler(item.value)
              }}
              key={item.value}
              className={
                props.isMultiple
                  ? props.activeFilters.indexOf(item.value) !== -1
                    ? 'label active'
                    : 'label'
                  : props.activeFilters === item.value
                    ? 'label active'
                    : 'label'
              }
            >
              {props.isMultiple && (
                <div>
                  {props.activeFilters.indexOf(item.value) !== -1 ? '✔' : ''}
                </div>
              )}
              <span>{item.label}</span>
            </div>
          ))}
        </div>
      )}
    </>
  )
})

Dropdown.displayName = 'Dropdown'
export default Dropdown
